import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '../../../../node_modules/@angular/forms';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-recuperar-cliente',
  templateUrl: './recuperar-cliente.component.html',
  styleUrls: ['./recuperar-cliente.component.css']
})
export class RecuperarClienteComponent implements OnInit {

  
  @ViewChild("mensajeRecuperar") mensajeRecuperar: ElementRef;
  @ViewChild("formulario") formulario: ElementRef;

  cliente={};

  constructor(private renderer:Renderer2, private auth:AuthService, 
    private router:Router, private activatedRoute:ActivatedRoute) { }

  ngOnInit() {
    if(this.auth.isAuthenticated()){
      
      this.router.navigate(['home']);
    }
  }

  guardarNuevaPass(myform: NgForm){
    this.renderer.addClass(this.formulario.nativeElement, "ng-submitted");
    
    if(myform.valid){
      
      this.auth.recuperarPassCliente(this.cliente)
      .subscribe(resp=>{
        let texto=this.renderer.createText("");
                
        if(resp["err"]==false){
          texto=this.renderer.createText("Se le ha enviado su nueva contraseña al correo.");
          this.renderer.setStyle(this.mensajeRecuperar.nativeElement,"color", "green");
        }else{
          texto=this.renderer.createText(resp["msg"]);
          this.renderer.setStyle(this.mensajeRecuperar.nativeElement, "color", "red");
        }
        this.renderer.appendChild(this.mensajeRecuperar.nativeElement, texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeRecuperar.nativeElement, texto);
        }, 1500);

      });
      
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/recuperar-cliente/recuperar-cliente.component.ts